import styled from 'styled-components';
import { Breakpoints, Color, Grid, Type } from '../../../app/StyleGuide';

export const SmallTag = styled.div`
  background-color: ${Color.Gray._05};
  padding: ${Grid._2} ${Grid._4};
  border-radius: ${Grid._3};
  font-size: ${Type.Scale._1};
  font-weight: ${Type.Weight.semibold};
  text-align: center;

  @media (max-width: ${Breakpoints.screen_sm}) {
    font-size: ${Type.Scale._05};
  }
`;
